import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { AppProvider } from './core/main';

const root = createRoot(document.getElementById('root'));
root.render(<AppProvider />);
